import { getSogniClientInstance } from '../sogni-client.svelte.js';
import { auth, isSogniReady, openLoginModal } from '../state/auth.svelte.js';

/**
 * Sign-in gate for everything that spends Sogni credits (LLM calls and image
 * generation). All of it runs on the signed-in user's own account through the
 * browser SDK; the Vibe server holds no generation or LLM path, so there is no
 * guest fallback.
 */

export const CONNECTING_MESSAGE = 'The Sogni network is still connecting. Please try again in a few seconds.';

export function connectingError() {
  const error = new Error(CONNECTING_MESSAGE);
  error.kind = 'connecting';
  return error;
}

/**
 * Return the signed-in user's SDK client. Signed out: open the sign-in modal and
 * throw an AUTH_REQUIRED error carrying `message`. Signed in (or still being
 * restored at boot) but not ready yet: throw the "still connecting" error.
 */
export function requireSignedInClient(message) {
  // The boot-time SSO probe has not finished: the user may well be signed in.
  if (auth.isRestoring) {
    throw connectingError();
  }

  if (!auth.isLoggedIn) {
    openLoginModal();
    const error = new Error(message);
    error.code = 'AUTH_REQUIRED';
    throw error;
  }

  const client = getSogniClientInstance();
  if (!client || !isSogniReady()) {
    throw connectingError();
  }

  return client;
}
